import React, { useState } from 'react';

const Help = () => {

    const [isOpen, setIsOpen] = useState(true);

    // const openPopup = () => {
    //     document.querySelector('.c_help-popup__video-overlay').classList.add('c_video-open');
    // }

    const togglePopup = () => {
        setIsOpen(!isOpen);
    }

    return (
        <>
            <div className="c_help__btn" onClick={togglePopup}>
                <img alt="" src="https://tanki-media-content.tanki.su/ptl/dailyRewards/img/help.png" />
            </div>
            <div className={isOpen ? "c_help-popup__overlay" : "c_help-popup__overlay c_active"}>
                <div className="c_help-popup__overlay-bg" onClick={(e) => {
                    togglePopup()
                }}></div>
                <div className="c_help-popup">
                    <div className="c_help-popup__body">
                        <div className='c_help-popup__close' onClick={(e) => {
                            togglePopup()
                        }}>
                            <img alt="" src="https://tanki-media-content.tanki.su/ptl/dailyRewards/img/close.svg" />
                        </div>
                        <div className="c_help-popup__content">
                            <div className="c_help-popup__text">
                                <div className='c_help-popup__title'>Правила</div>
                                <p className='c_help-popup__help-text'>* Награда может приходить с некоторой задержкой. Пожалуйста, не забудьте получить её в клиенте, иначе вы не сможете забирать награды в дальнейшем.</p>
                                <ol className='c_help-popup__list'>
                                    <li>Заходите в календарь и забирайте награду текущего дня. </li>
                                    <li>После этого обязательно зайдите в клиент, чтобы награда была доставлена. </li>
                                    <li>В день можно забрать только одну награду, они становятся доступны последовательно.</li>
                                    <li>Обновление игрового дня происходит в 3:00 (МСК). </li>
                                    <li>Если вы забрали награду в календаре, но не зашли в игру до 3:00 (МСК) следующего дня, награда не будет доставлена. Пока вы её не заберёте, награда следующего дня не откроется. </li>
                                    <li>Если вы пропустили день или несколько, то по возвращении вы будете забирать награды по одной с того дня, на котором остановились.</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Help;